angular.module('pitch.app')
.controller('SongwritersCtrl', function($scope, contentsLoader, ABCFilterModal, $stateParams) {
    "use strict";

    $scope.page = $stateParams.page ? parseInt($stateParams.page) : 0;
    $scope.songWriterLoader = contentsLoader.getPage($scope.page);

    $scope.showFilters = function() {
        ABCFilterModal.open();
    };
});



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/controllers/SongwritersCtrl.js